export enum ShipmentRequestLocationType {
  PickUp = 'PICK_UP',
  Delivery = 'DELIVERY',
  Return = 'RETURN',
  Start = 'START',
  InTransit = 'IN_TRANSIT'
}
